export const storeKey = "chart"

export const fallbackUpdateTimeInterval = 2000

// corresponds to force_update_at in old dashboard
// throttle time between use globalPanAndZoom change actions - and requests sent to server
export const panAndZoomDelay = 300
